export function toTitleCase(str: string) {
  return str.replace(/\w\S*/g, function(txt: string) {
    return txt.replace(/_/g, ' ').replace(/\w\S*/g, txt => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    })
  })
}
